export enum Locale {
  US = 'us',
  RO = 'ro'
}
